import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { SessionService } from '../services/session.service';

/**
 * Resolves whether a session exists, sending signed-out users to login with the
 * attempted URL. Call it from an injection context, such as another guard.
 */
export function requireSession(url: string): Observable<boolean> {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  return sessionService.getOneSession$.pipe(
    tap(session => {
      if (!session) void router.navigate(['/login', { redirectTo: url }]);
    }),
    map(session => !!session),
  );
}

export const authGuard: CanActivateFn = (_route, state) => requireSession(state.url);
